"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _MdStar = require("@react-icons/all-files/md/MdStar");

var _MdStarHalf = require("@react-icons/all-files/md/MdStarHalf");

var _nanoid = require("nanoid");

var _react = _interopRequireWildcard(require("react"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _ResponsiveProvider = require("../../framework/ResponsiveProvider/ResponsiveProvider.index");

var _BazaarVoice = _interopRequireDefault(require("../BazaarVoice/BazaarVoice.context"));

var _ProductReviews = require("./ProductReviews.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var bvReviewsContainerId = 'BVRRContainer';

var renderReviewsSummary = function renderReviewsSummary(ratingsData) {
  if (!ratingsData) {
    return null;
  }

  var starRating = ratingsData.starRating,
      totalReviewCount = ratingsData.totalReviewCount;
  var stars = parseInt(starRating, 10);
  var isDecimal = starRating % 1 !== 0;
  return /*#__PURE__*/_react["default"].createElement(_ProductReviews.StyledReviewsSummary, null, /*#__PURE__*/_react["default"].createElement(_ProductReviews.StyledReviewsCount, null, /*#__PURE__*/_react["default"].createElement("span", null, totalReviewCount), ' Reviews'), /*#__PURE__*/_react["default"].createElement(_ProductReviews.StyledReviewsStars, null, (0, _toConsumableArray2["default"])(Array(stars)).map(function () {
    return /*#__PURE__*/_react["default"].createElement(_MdStar.MdStar, {
      key: (0, _nanoid.nanoid)()
    });
  }), isDecimal && /*#__PURE__*/_react["default"].createElement(_MdStarHalf.MdStarHalf, null)));
};

var ProductReviews = function ProductReviews() {
  var context = (0, _react.useContext)(_BazaarVoice["default"]);
  var getBVApi = context.getBVApi,
      isLazy = context.isLazy,
      ratingsData = context.ratingsData,
      productId = context.productId;

  var _useBreakpoint = (0, _ResponsiveProvider.useBreakpoint)(),
      isSmall = _useBreakpoint.isSmall;

  return isLazy ? /*#__PURE__*/_react["default"].createElement(_reactIntersectionObserver.InView, {
    onChange: function onChange(isInView) {
      return isInView && getBVApi();
    },
    triggerOnce: true,
    threshold: 0.5
  }, isSmall && renderReviewsSummary(ratingsData), /*#__PURE__*/_react["default"].createElement("div", {
    id: bvReviewsContainerId,
    "data-bv-show": "reviews",
    "data-bv-product-id": productId
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isSmall && renderReviewsSummary(ratingsData), /*#__PURE__*/_react["default"].createElement("div", {
    id: bvReviewsContainerId,
    "data-bv-show": "reviews",
    "data-bv-product-id": productId
  }));
};

ProductReviews.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProductReviews"
};
var _default = ProductReviews;
exports["default"] = _default;